import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-date',
  templateUrl: './edit-date.component.html',
  styleUrls: ['./edit-date.component.css']
})
export class EditDateComponent implements OnInit {

  label: string;

  // @Input label: string;

  constructor() {

    this.label = "Patata";

  }

  ngOnInit() {
  }

  elementChange(hola: any) {
    console.log(hola);
  }

}
